/* global axios */
import ApiClient from './ApiClient';

// Motivos de pérdida de la cuenta (P10). Los lee cualquier usuario; crear,
// renombrar, ordenar, desactivar y borrar es de administradores.
class PipelineLostReasonsAPI extends ApiClient {
  constructor() {
    super('pipeline_lost_reasons', { accountScoped: true });
  }

  get({ includeInactive = false } = {}) {
    return axios.get(this.url, {
      params: includeInactive ? { include_inactive: true } : undefined,
    });
  }

  // `names` guarda varias sugerencias de una vez (las repetidas se saltean).
  // La respuesta trae el catálogo completo; con `includeInactive` (solo vale
  // para administradores) incluye también los desactivados.
  createMany(names, { includeInactive = false } = {}) {
    return axios.post(this.url, {
      names,
      ...(includeInactive ? { include_inactive: true } : {}),
    });
  }

  reorder(ids, { includeInactive = false } = {}) {
    return axios.post(`${this.url}/reorder`, {
      ids,
      ...(includeInactive ? { include_inactive: true } : {}),
    });
  }
}

export default new PipelineLostReasonsAPI();
